import isEqual from 'lodash/isEqual';

export const getKeyByValue = (object: Record<string, unknown>, value: unknown): string | undefined => {
  return Object.keys(object).find((key) => object[key] === value);
};

export type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? // @ts-ignore
      `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

/**
 * Validates if a list has specific items(s)
 * Returns false if not found or if item's property is disabled/false
 * @param element
 * @param mainList
 * @param id
 * @param nestedDisabledKey
 * @param strict
 */
export const validateListContains = <T, R>(
  element: T | T[],
  mainList: R[] | undefined,
  id: keyof R,
  nestedDisabledKey: keyof R,
  strict?: boolean,
) => {
  try {
    if (!mainList) {
      return false;
    }

    const list = Array.isArray(element) ? element : [element];

    for (let i = 0; i < list.length; i++) {
      const item = list[i];

      const existingitem = mainList.find((el) => isEqual(el[id], item));

      if (!existingitem) {
        if (strict) {
          return false;
        }

        continue;
      }

      if (strict && i < list.length - 1) {
        continue;
      }

      return !existingitem[nestedDisabledKey];
    }
  } catch {
    return false;
  }

  return false;
};
